<template>
  <div class="wrapper">
    <Mv />
    <div class="content">
      <h1 class="content-title remove_border">NP FAN CLUB</h1>
      <div class="content_text w-600 center text-center wsnw mb-20">
        「NP FAN CLUB」は、<wbr>ナチュラリープラスビジネスを<br>
          <strong class="fs-11">「する」</strong>という<strong class="fs-11">「決断」</strong><br>
          をした方々が集まるプラットフォームです。
      </div>
      <div class="benefits-area center">
        <h3 class="benefits-title center">NP FAN CLUB入会特典</h3>
        <ul>
          <li class="benefits-item">fellow Training受講資格
            <p class="fs-09 fw-normal mb-0">代表取締役社長 田嶋隆志による、ナチュラリープラスビネスを成功へと導く特別トレーニングを受講いただけます。</p>
          </li>
          <li class="benefits-item">
            アプリ CONPUS NP FAN CLUB専用メニュー
            <p class="fs-09 fw-normal mb-0">「fellow Training、LEADERS」などがご利用いただけます。<br>さらにCONPUSにはfellow限定のお知らせなどナチュラリープラスのビジネスに役立つ情報が届きます。</p>
          </li>
          <li class="benefits-item">
            NP FAN CLUB限定キャンペーンへの参加権利
            <p class="fs-09 fw-normal mb-0">お得なキャンペーンを開催いたします。</p>
          </li>
          <li class="benefits-item">
            NP FAN CLUB fellow限定ライブ配信
            <p class="fs-09 fw-normal mb-0">会員専用インターネット放送局NP FAN’S TVで配信される、fellow限定のスペシャルライブ番組をご視聴いただけます。</p>
          </li>
        </ul>
        <p class="benefits-sub">その他さまざまな特典がございます。</p>
        <p class="benefits-sub apply_text">※詳細はナチュラリープラスまで</p>


      </div>
      <div class="add_header_btn--wrap">
        <!-- <a href="https://www.secure-cloud.jp/sf/business/sp/1596596255KXyfxnJL" class="add_header_btn">お申し込みはこちら</a> -->
        <!-- <router-link class="add_header_btn" :to="{ name: 'fanClubTerms', params: {} }">詳細はナチュラリープラスまで</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import Check from '@/model/getToken'
import Mv from '@/components/fanClub/RegisterMv'

export default {
  components: {
    Mv
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      let redirectUrl = this.$route.query.redirectUrl;
      if(redirectUrl) {
        this.$store.commit('setFanClubRedirectUrl', redirectUrl);
      }
    } else {
      // this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.wrapper {
  background-color: #f7f5f1;
  font-family: 'ヒラギノ角ゴ Pro W3','Hiragino Kaku Gothic Pro','メイリオ','Mayryo','ＭＳ Ｐゴシック','MS PGothic',sans-serif;
}

.content-title {
  color: #303030;
  font-weight: bold;
}

.content_text {
  color: #303030;
  font-size: 14px;
  text-align: center;
}
.fs-11 {
  font-size: 16px;
}

.fs-09 {
  font-size: 14px;
  font-weight: normal;
  margin-top: 14px;
}

.benefits-area {
  margin: 20px auto 0;
}

.wrapper {
    min-width: 768px;
    width: 100%;
    height: auto;
    margin: 0px auto;
}
/**
* contents
*/
.content {
  padding: 0 0 20px;
  width: 100%;
}


.content .image {
    text-align: center;
    margin: auto;
    width: 100%;
    height: auto;
}

.content .image img {
    width: 100%;
    height: auto;
}

.content-title {
    text-align: center;
    width: 80%;
    min-width: 300px;
    max-width: 640px;
    margin: 0 auto 20px;
    padding-top: 0.5rem;
    border-bottom: 4px double #080d49;
}

.content-main {
    margin: 0 auto;
}

/**
* step 06-01
*/

.benefits-area {
    background-color: #080d49;
    width: 90%;
    max-width: 600px;
    padding: 0 15px;
    margin-top: 20px;
}

.benefits-area ul {
    background-color: #fff;
    margin-top: 0;
    padding-left: 40px;
}

.benefits-sub {
    color: #a1a1a1;
    font-size: 14px;
    margin-top: 10px;
    /* padding-bottom: 10px; */
}

.benefits-title {
    background-size: cover;
    background-position: center;
    font-weight: bold;
    font-size: 18px;
    max-width: 450px;
    margin-top: 10px;
    text-align: center;
    line-height: 90px;
    height: 100px;
    color: rgb(83, 72, 6);
}

.benefits-item {
    list-style-type: decimal;
    color: #080d49;
    font-size: 16px;
    font-weight: bold;
    padding: 15px 0;
    margin-right: 20px;
    border-bottom: 2px solid;
    border-image: linear-gradient(to right, #e3e3e3 0%, #aaa 30%, #fefefe 100%) 1/0 0 1px 0;;
    border-image-slice: 1;
    border-style: solid;
}

.benefits-item:last-child {
    border-bottom: none;
}

/* .content-titleの下線削除 */
.remove_border {
    border: none;
    margin-bottom: 10px !important;
    padding-bottom: 0 !important;
}

/* 2021/02/08お申し込みはこちらボタン追加 */
.add_header_btn--wrap {
    /* border-bottom: 4px double #080d49;
    min-width: 300px;
    max-width: 640px;
    margin: 0 auto 20px;
    padding-bottom: 1.5rem;
    width: 80%; */
    margin: 20px auto;
    width: 80%;
}
.add_header_btn--wrap .add_header_btn {
    background-color: #000;
    border: 1px solid  #000;
    border-radius: 20px;
    box-shadow: 0px 6px 6px rgba(0, 0, 0, .6);
    color: #fff;
    display: block;
    font-weight: bold;
    font-size: 17px;
    max-width: 400px;
    margin: auto;
    padding: 20px 5px;
    text-align: center;
    transition: all .3s;
    width: 90%;
}

.add_header_btn--wrap .add_header_btn:hover {
    background-color: #fff;
    color: #000;
}


@media screen and (max-width: 992px) {
    .wrapper {
        min-width: 320px;
    }

    .content-title {
        line-height: 1.8rem;
        font-size: 1.6rem;
    }

    .content-main {
        padding: 0 10px;
    }

    /* .content .video img,
    .content .image img {
        width: 100% !important;
        max-width: 640px !important;
        height: auto !important;
        max-height: 360px !important;
    } */

    .download-pdf-img-btn {
        width: 60%;
    }

    .summary-document-title {
        background-size: 22px 22px;
        padding-left: 25px;
    }

    .benefits-title {
        line-height: 70px;
        height: 80px;
    }


    .sns-link,
    .appli-link {
        text-align: center;
    }

}

@media screen and (max-width: 767px) {
    body {
        font-size: 0.9em;
    }
}

.apply_text {
  /* color: #fff; */
  font-size: 18px;
  margin-top: 0;
  text-align: center;
  padding-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/fanClub/register/Apply.vue